export const IDP_PRIORITIES = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
};

export const IDP_PRIORITY_OPTIONS = [
  { value: IDP_PRIORITIES.LOW, label: 'Low' },
  { value: IDP_PRIORITIES.MEDIUM, label: 'Medium' },
  { value: IDP_PRIORITIES.HIGH, label: 'High' },
];

export const getPriorityLabel = (priority) => {
  const option = IDP_PRIORITY_OPTIONS.find(opt => opt.value === priority);
  return option?.label || priority;
};

export const IDP_USAGE_STATUSES = {
  NOT_USED: 'NotUsed',
  IN_PROGRESS: 'InProgress',
  USED: 'Used',
};

export const IDP_USAGE_STATUS_OPTIONS = [
  { value: IDP_USAGE_STATUSES.NOT_USED, label: 'Not Used' },
  { value: IDP_USAGE_STATUSES.IN_PROGRESS, label: 'In Progress' },
  { value: IDP_USAGE_STATUSES.USED, label: 'Used' },
];

export const getUsageStatusLabel = (status) => {
  const option = IDP_USAGE_STATUS_OPTIONS.find(opt => opt.value === status);
  return option?.label || status;
};
